/* eslint-disable eqeqeq */

import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import trackAnalytics from '../../utils/gaia/trackAnalytics';

export interface EditDescriptionDialogProps {
    apiType: string; // The dir on the API to post to.
    apiEndpoint: string;
    open: boolean;
    originalText: string; // The machine generated description.
    onRequestClose: () => void; // Method to hide this dialog.
    regionType: string; // Can be park or hike.
    regionId: number; // The id of the park or hike.
    text: string; // The user generated description on open.
    title: string;
    hint?: string;
    afterUpdate: (text: string) => void;
    template: string;
}

interface EditDescriptionDialogState {
    textInField: string;
    didEdit: boolean;
}

/**
 * EditDescriptionDialog component for editing a description for a hike or park.
 * Material-UI Dialog.
 *
 * ---------------------------
 * | Title            Buttons |
 * ---------------------------
 * | TextField                |
 * |                          |
 * ---------------------------
 */

export default class EditDescriptionDialog
    extends React.Component<EditDescriptionDialogProps, EditDescriptionDialogState> {

    constructor(props: EditDescriptionDialogProps) {
        super(props);
        this.state = {
            didEdit: false,
            textInField: props.text || props.originalText,
        };
    }

    // called when the user types into the TextField
    handleTextEdit(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
        this.setState({
            didEdit: true,
            textInField: event.target.value,
        });
    }

    // called when the user presses Save - posts to Server and updates description on page
    saveText() {
        // eslint-disable-next-line max-len
        const url = `/api/trip/${this.props.apiEndpoint}/${this.props.regionType}/${this.props.regionId}/`;

        let data = null;
        let logType = '';
        if (this.props.apiType == 'title') {
            data = {title: this.state.textInField};
            logType = 'Save Title';
        } else {
            data = {flagged_note: this.state.textInField, flagged: true};
            logType = 'Save Flag';
        }

        trackAnalytics(logType, {
            category: 'Hike',
            regionId: this.props.regionId,
            regionType: this.props.regionType,
            text: this.state.textInField,
            path: window.location.pathname,
        });

        fetch(url,
            {
                body: JSON.stringify(data),
                method: 'POST',
                credentials: 'same-origin'
            }
        )
            .then(response => {
                return response.json();
            })
            .then(myJson => {
                if (!myJson.success && myJson.errors) {
                    console.error(myJson);
                }
            });

        // if the user deleted the title/description, use the original machine generated one
        if (this.props.apiType != 'flagged_note') {
            if (!this.state.textInField.length) {
                this.setState({
                    textInField: this.props.template || this.props.originalText,
                });
            }
        }
        this.props.afterUpdate(
            this.state.textInField.length ? this.state.textInField : this.props.originalText
        );
        this.props.onRequestClose();
    }

    render() {
        const actions = [
            <Button key={0} variant="text" onClick={this.props.onRequestClose}>Cancel</Button>,
            <Button
                key={1}
                variant="text"
                color='primary'
                onClick={() => this.saveText()}
                disabled={!this.state.didEdit}>Save</Button>,
        ];

        let rows = 10;
        let width = '40vw';
        if (this.props.apiType == 'flagged_note') {
            rows = 20;
            width = '60vw';
        }
        const helperNode = <span>{this.props.hint}</span>;

        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.onRequestClose}
                maxWidth={false}
            >
                <div style={{width: width}}>
                    <DialogTitle className="dialog-title">{this.props.title}</DialogTitle>
                    <DialogContent>
                        <div>
                            <TextField
                                margin='dense'
                                variant='outlined'
                                value={this.state.textInField}
                                onChange={e => this.handleTextEdit(e)}
                                id="textField"
                                helperText={helperNode}
                                multiline={true}
                                rows={rows}
                                rowsMax={50}
                                fullWidth />
                        </div>
                        <DialogActions>
                            {actions}
                        </DialogActions>
                    </DialogContent>
                </div>
            </Dialog>

        );
    }
}
